import React from "react";
import {EditorState} from 'react-draft-wysiwyg';
import { Icon } from "src/components";
import { theme } from "src/config";
import styled from "styled-components";


export interface IToolbarButtonProps {
  editorState?:  EditorState,
  translations?: any,
  onChange?:     any // @TODO find out types here
}


export interface ISaveButtonProps extends IToolbarButtonProps {
  onClick?: (editorState:  EditorState) => EditorState,
}

export const SaveButton = (props: ISaveButtonProps) => {
  return (
    <CustomButton 
      onClick={() => {
        let c: EditorState;
        if(props.onClick) c = props.onClick(props.editorState);
        props.onChange(c || props.editorState);
      }} 
      style={{marginLeft: "auto", marginRight: "0.5rem"}}
    >
      <Icon size="large" color={theme.color.black} iconId="save" />
    </CustomButton>
  );
}

export interface IDiscardButtonProps extends IToolbarButtonProps {
  onClick?: (editorState:  EditorState) => EditorState,
}

export const DiscardButton = (props: IDiscardButtonProps) => {
  return (
    <CustomButton onClick={() => {
      let c: EditorState;
      if(props.onClick) c =  props.onClick(props.editorState);
      props.onChange(c || props.editorState);
    }}>
      <Icon size="large" iconId="delete" />
    </CustomButton>
  );
}

const CustomButton = styled.div`
  cursor:        pointer;
  align-self:    center;
  border:        1px solid ${theme.color.primaryBorder};
  border-radius: 0.2rem;
  padding:       0.3rem;
  height:        3rem;
  width:         3rem;
  margin-bottom: 0.5rem;

  :hover {
    background-color: ${theme.color.slate3};
  }

  :active {
    outline: 2px solid ${theme.color.buttons.primary.active};
  }
`;